export default __webpack_public_path__ + "0c31634.png";